<template>
	<div class="modal-wrapper" @click="close">
		<div class="modal-container" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12">
						EDITAR SEQUÊNCIA - {{ journey.vehicleLicensePlate }}
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="container-list">
					<div class="row">
                        <div class="col-xs-12">
                            <p class="description"><b><i class="fa fa-fw fa-info-circle"></i> Arraste e solte</b> as entregas para editar a sequência</p>
                        </div>
						<div class="col-xs-12">
							<button class="button-edit button-select" @click="reverseNodes">
								<i class="fa fa-fw fa-exchange-alt fa-rotate-90"></i> INVERTER SEQUÊNCIA
							</button>
						</div>
                        <div class="col-xs-12">
                            <div class="row list-group-title-item">
                                <div class="col-xs-1">ATUAL</div>
                                <div class="col-xs-2">NÚMERO</div>
                                <div class="col-xs-4">CLIENTE</div>
                                <div class="col-xs-4">ENDEREÇO</div>
                                <div class="col-xs-1">PESO</div>
                            </div>
                            <div class="list-group" ref="nodesList" :style="{'height': maxHeight }">
                                <div class="row list-group-item pointer" v-for="(point, index) in nodesList" :key="'node_' + index" :data-document="point.documentIdentifier" ref="listGroupItemNode">
									<div class="col-xs-1 list-group-item-col">{{ point.sequence }}</div>
									<div class="col-xs-2 list-group-item-col">{{ point.documentNumber }}</div>
                                    <div class="col-xs-4 list-group-item-col capitalized">
										{{ point.customerName.toLowerCase() }}<br/>
										<span v-if="client_atak && (point.movimentTypeCode == default_moviment_type_code)" class="stopping-item"><b><i class="fas fa-exclamation-triangle"></i> Ponto de parada</b></span>
									</div>
                                    <div class="col-xs-4 list-group-item-col capitalized">{{ point.addressStreet.toLowerCase() + ", " + point.addressNumber + " - " + point.addressNeighborhood.toLowerCase() + ", " + point.addressCity.toLowerCase() + " - " + point.addressUf + ", " + point.addressPostalCode }}</div>
									<div class="col-xs-1 list-group-item-col">{{ point.weight ? getWeight(point.weight) : "0,00 kg"}}</div>
									<div v-if="point.observationID" class="col-xs-2 col-lg-12 list-group-item-col"><p class="description-item"><b><i class="fa fa-fw fa-info-circle"></i> Observação:</b> {{ point.observation }}</p></div>
                                </div>
                            </div>
                        </div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row">
					<div class="col-xs-12 col-lg-8">
						<div class="row">
							<div class="col-xs-12 col-lg-6">
								<div class="row">
									<div class="col-xs-12">
										<p class="description-weight">Veículo <b>{{ journey.vehicleLicensePlate }}</b></p>
									</div>
									<div class="col-xs-4 col-lg-4 total-weight">
										<span class="total-weight-percent" ref="totalWeightPercent">{{ totalWeightPercent.toFixed(1) }} %</span>
									</div>
									<div class="col-xs-8 col-lg-8 total-weight">
										<i class="fa fa-fw fa-truck-loading"></i> {{ getWeight(totalWeight) }} / <i class="fa fa-fw fa-truck"></i> {{ getWeight(vehicleWeightCapacity) }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-lg-offset-2 col-lg-2">
						<button class="button-route" @click="updateSequence" :disabled="loading">
							<i :class="'fa fa-fw' + (loading ? ' fa-circle-notch fa-spin' : ' fa-sync-alt')"></i> ATUALIZAR
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Sortable } from "sortablejs";

export default {
	name: "RoutingModalSequence",

	props: {
		journey: {
			type: Object,
			require: true
		},
		journeyIndex: {
			type: Number,
			require: true,
		},
		client_atak: {
			type: [Number, Boolean],
			require: true,
		},
		default_moviment_type_code: {
			type: String,
			require: false,
			default: "",
		},
	},

	data: function() {
		return {
			loading: false,
			dcList: [],
			nodesList: [],
			
			vehicleWeightCapacity: 0,
			totalWeight: 0,
			totalWeightPercent: 0,

			maxHeight: "100%",
		}
	},

	mounted: function() {
		// Define a capacidade do veículo
		this.processNodesList();
		this.processWeight();
		this.initSorteable();
	},

	updated: function() {
		this.calcHeight();
	},

	methods: {
		/**
		 * Processa a lista de entregas roteirizadas
		 */
		processNodesList: function() {
			// Percorre a lista dos pontos de entrega
			this.journey.points.map(point => {
				// Verifica se é um ponto de entrega
				if(!point.isDC) {
					// Adiciona na lista de entregas
					this.nodesList.push(point);
					
					// Soma o peso ao total da carga
					this.totalWeight += point.weight;
				} else {
					// Salva o ponto do dc inicial
					this.dcList.push(point);
				}
			});
		},
		// Processa o peso e capacidade
		processWeight: function () {
			this.vehicleWeightCapacity = parseInt(this.journey.vehicleWeightCapacity);

			//if(this.journey.weightConstraints) {
				this.totalWeightPercent = (this.totalWeight * 100) / this.vehicleWeightCapacity;
			/*} else {
				this.totalWeightPercent = 0;
			}*/
			
			let backgroundColor = "";
			let borderColor = "";
			if(this.totalWeightPercent <= 50) {
				backgroundColor = "#64ff64";
				borderColor = "#0dac0d";
			} else if((this.totalWeightPercent > 50) && (this.totalWeightPercent < 90)) {
				backgroundColor = "#ffc965";
				borderColor = "#b77c10";
			} else {
				backgroundColor = "#faa";
				borderColor = "#f55";
			}

			this.$refs.totalWeightPercent.style.background = "linear-gradient(90deg, " + backgroundColor + " " + this.totalWeightPercent + "%, white " + this.totalWeightPercent + "%)";
			this.$refs.totalWeightPercent.style.borderColor = borderColor;
		},
		
		/**
		 * Inicia o componente sorteable nas lista
		 */
		initSorteable: function() {
			// Lista das entregas roteirizadas
			this.sortableNodes = new Sortable(this.$refs.nodesList, {
				group: "list",
				sort: true,
				multiDrag: true,
				selectedClass: "item-selected",
				fallbackTolerance: 3,
				animation: 150,
				dataIdAttr: "data-document",
				onEnd: () => {
					this.calcHeight();
				},
			});
		},

		/**
		 * Inverte a orde da lista
		 */
		reverseNodes: function() {
			var order = this.sortableNodes.toArray();
			this.sortableNodes.sort(order.reverse(), true);
		},
		
		/**
		 * Processa a atualização da rota
		 */
		updateSequence: async function() {
			// Inicia as variávei necesárias
			let list = this.sortableNodes.toArray();
			let journeyResult = [];
			let pointsList = [];

			// Pede uma confirmação
			let confirm = await this.$alert.confirm("Deseja definir esta sequência para o veículo " + this.journey.vehicleLicensePlate + "?", "AVISO");
			
			// Verifica a resposta
			if(!confirm) {
				return;
			}

			this.loading = true;
			
			// Adiciona o ponto do centro de distribuição
			pointsList.push(this.dcList[0]);
			
			// Percorre a lista modificada
			list.forEach((document, index) => {
				// Percorre a lista de pontos
				for (let i = 0; i < this.nodesList.length; i++) {
					if (this.nodesList[i].documentIdentifier == document) {
						this.nodesList[i].sequence = index + 1;
						this.nodesList[i].packageSequence = list.length - index;
						pointsList.push(this.nodesList[i]);
						break;
					}
				}
			});

			// Adiciona no final o ponto do centro de distribuição
			if (this.journey.returnOrigin) {
				pointsList.push(this.dcList[1]);
			}

			// Adiciona a lista de entregas deste veículo
			journeyResult = {
				index: this.journeyIndex,
				hasRoute: true,
				journey: this.journey,
				totalWeight: this.totalWeight,
				points: pointsList,
			};
			
			// Emite o resultado
			this.$emit("updating", journeyResult);

			this.loading = false;
		},

		calcHeight: function() {
			let aux = 0;

			let listGroupItensNode = this.$refs.listGroupItemNode;
			if (listGroupItensNode) {
				listGroupItensNode.map((element) => {
					aux += element.clientHeight;
				});
				aux += listGroupItensNode.length * 10;
			}
			
			this.maxHeight = aux > 0 ? aux + "px" : "100%";
		},

		getWeight: function(weight) {
            let weight_formatted = "";

            if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
            else weight_formatted = (weight / 1000).toFixed(2) + " t";

            return weight_formatted.replace(".", ",");
        },

		/**
		 * Fecha o modal
		 */
		close: function() {
			this.$emit("close");
		},
	}
}

</script>


<style scoped>

.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	height: 50px;
	line-height: 50px;
	padding: 0px 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}
.modal-body {
	padding: 15px;
	height: calc(100vh - 151px);
	width: 100%;
	overflow-y: auto;
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: auto;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

p.description {
	margin-block-start: 0px;
	margin-block-end: 15px;
	padding: 5px;
	background-color: #ccc;
	border-radius: 4px;
	font-size: 12px;
}

p.description-item {
	margin-block-start: 5px;
	margin-block-end: 5px;
	padding: 5px;
	background-color: #ccc;
	border-radius: 4px;
	font-size: 12px;
}

p.description-weight {
	margin-block-start: 0px;
	margin-block-end: 0px;
	margin-top: 3px;
	font-size: 12px;
}

.vehicle-selected {
	margin-top: -10px;
}

.list-group-vehicle-selected {
	margin-bottom: 30px;
	min-height: 125px;
}

p.description-vehicle-selected {
	margin-block-start: 0px;
}

p.table-description {
	margin-block-start: 0px;
	margin-block-end: 5px;
	font-size: 14px;
}

.list-left {
	position: relative;
	padding-right: 30px;
}

.list-left > span {
	position: absolute;
	right: 0;
	margin-top: 30px;
}

.list-right {
	position: relative;
	padding-left: 30px;
}

.list-group {
	width: 100%;
	/*height: 100%;*/
	text-align: left;
	border: 2px dashed #ddd;
	background-color: #fafafa;
}

.list-group-title-item {
	margin: 0px 0px 5px;
	font-size: 14px;
	border-top: 1px solid #ccc;
	border-bottom: 1px solid #ccc;
	padding-top: 5px;
	padding-bottom: 5px;
	background-color: #eee;
}

.list-group-item {
	margin: 5px 5px;
	padding-top: 10px;
	padding-bottom: 10px;
	font-size: 13px;
	border: 1px solid #ccc;
	border-radius: 3px;
	background-color: #fff;
    /*box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;*/
}

.list-group-item-number {
	margin: 5px 0px;
	padding-top: 10px;
	padding-bottom: 10px;
	font-size: 13px;
}

.list-group-item:hover {
	background-color: #f0f0f0;
}

.list-group-item-col {
	display: grid;
	align-content: center;
	min-height: 30px;
}

.pointer {
	cursor: pointer;
}

.grab {
	cursor: -webkit-grab;
	cursor: grab;
}

.total-weight {
	padding-top: 3px;
	padding-bottom: 3px;
	font-size: 14px;
}

.total-weight-percent {
	display: block;
	padding: 1px 10px;
	color: #000;
	border: 1px solid;
	text-align: center;
	font-size: 12px;
}

.list-group-empty {
	margin-top: -90px;
	padding-top: 36px;
	padding-bottom: 36px;
	font-size: 12px;
	text-align: center;
	border: 2px dashed #ccc;
    border-radius: 3px;
}

.container-simbol {
	text-align: center;
	margin-bottom: 30px;
}

.container-simbol > i {
	margin-top: 30px;
}

.button-route {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}

.item-selected {
	background-color: #f0f0f0;
}

.button-route:disabled {
	background: #a0a0a0
}
.button-select {
	font-size: 12px;
	margin-bottom: 15px;
}

span.stopping-item {
	margin-top: 5px;
    padding: 5px;
    border-radius: 4px;
    background-color: #ccc;
    color: #404040;
    font-size: 10px;
    width: max-content;
}
</style>